import store from "../redux/store";

export function useIsHoa(): boolean {
  const user = store.getState().auth.user;
  const userRoles = user?.roles || [];
  return userRoles.includes('hoa');
}
